module.exports = __webpack_public_path__ + "img/news3.46b299f0.jpg";